module.exports = __webpack_public_path__ + "static/img/EECloud大企业业财一体化AI.60abf49d.png";